import * as React from 'react';
var signIn = function () {
    var url = '/auth/linkedin';
    var windowName = 'signIn';
    var width = 720;
    var height = 640;
    var left = (window.outerWidth - width) / 2;
    var top = (window.outerHeight - height) / 2;
    window.open(url, windowName, [
        "width=" + width,
        "height=" + height,
        "left=" + left,
        "top=" + top,
    ].join(','));
};
export function useSignIn() {
    var _a = React.useState(false), done = _a[0], setDone = _a[1];
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
    function receiveMessage(event) {
        // Only trust messages from this origin
        if (event.origin !== window.location.origin) {
            return;
        }
        if (!event.source) {
            return;
        }
        // Close the pop up
        if (event.data.authenticated === true) {
            // Close the popup window
            event.source.close();
            setDone(true);
        }
        if (event.data.authenticated === false) {
            // console.error(event.data.errorReason);
            // Close the popup window
            event.source.close();
            setDone(true);
        }
    }
    React.useEffect(function () {
        window.addEventListener('message', receiveMessage, false);
        return function () {
            window.removeEventListener('message', receiveMessage, false);
        };
    }, []);
    return [signIn, done];
}
//# sourceMappingURL=use-sign-in.js.map